export default async function fetchWithRetry(
  url: string,
  options: any = {},
  attempts: number = 3,
  backoffMs: number = 1000
): Promise<Response> {
  let lastError: any = null;
  for (let attempt = 1; attempt <= attempts; attempt += 1) {
    try {
      const resp = await fetch(url, options);
      if (resp.ok) return resp;

      const retryable = resp.status >= 500 || resp.status === 429;
      if (!retryable || attempt === attempts) {
        let body = "";
        try { body = await resp.text(); } catch (_) { /* ignore */ }
        throw new Error(`HTTP ${resp.status}${body ? `: ${body}` : ''}`);
      }
    } catch (err) {
      lastError = err;
      if (attempt === attempts) throw err;
    }

    // Exponential backoff
    await new Promise((r) => setTimeout(r, backoffMs * Math.pow(2, attempt - 1)));
  }
  throw lastError || new Error('Request failed');
}
